<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Verwendungszweck</h2>
      <p class="step-text">Wofür benötigen Sie den Immobiliencheck?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-50"
          text="Kauf"
          @click="setVerwendung('KAUF')"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_43.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_43_white.svg')
          "
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Verkauf"
          @click="setVerwendung('VERKAUF')"
          :iconDefault="require('@/assets/icons/Svgs/Vereinigungsmenge_28.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Vereinigungsmenge_28_white.svg')
          "
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Bestandsimmobilie"
          @click="setVerwendung('BESTAND')"
          :iconDefault="require('@/assets/icons/Svgs/Wohnung_Bestand.svg')"
          :iconHover="
            require('@/assets/icons/Svgs/Wohnung_Bestand_white.svg')
          "
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { getFromStorage, isSet, saveToStorage } from "@/utils.js";
export default {
  name: "dg-wohnung-step-9",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        f_zweck: { value: null },
               flagBalkon: { value: null },
        flagTerrasse: { value: null },
        flagGarage: { value: null },
      },
    };
  },
  methods: {
    isSet: isSet,
    setVerwendung(f_zweck) {
      this.fields.f_zweck.value = f_zweck;
      saveToStorage(this.fields);
      this.$router.push("/dg-wohnung-step-10");
    },
    goBack() {
      if (
        isSet(this.fields.flagBalkon.value) || isSet(this.fields.flagGarage.value) ||
        isSet(this.fields.flagTerrasse.value)      ) {
        this.$router.push("/dg-wohnung-step-8b");
      } else {
        this.$router.push("/dg-wohnung-step-8a");
    }
  },
    },

  mounted() {
    this.$emit("setStep", "dg-wohnung", 11);
    getFromStorage(this.fields);

  },
};
</script>
<style scoped>
.box-item {
  flex-basis: 250px;
  height: 200px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    grid-auto-rows: minmax(150px, auto);
  }
  .box-item {
    height: 100%;
  }
}
</style>
